import {
	DOCUMENT_LIST_GENERIC_ACTIVITY_LIST_SORT,
	DOCUMENT_LIST_GENERIC_ACTIVITY_LIST_VIEW_MODE_LARGE,
} from 'src/stores/documentList/localStorageKeys';
import { TSMap } from 'typescript-map';

import { DateRangeSelection } from 'src/models/common';
import { DocumentListItem } from 'src/models/documentList';
import { FilterBoxes, FilterUsers } from 'src/models/filter';
import {
	ActivityListTypeEnum,
	GenericActivityListPagination,
	GenericActivityListSort,
} from 'src/models/genericActivityList';
import { PreconfiguredTimeRanges } from 'src/models/miniCalendar';
import { SharedQueryIdoDocumentBinding } from 'src/models/organization';
import { SerializedQuery } from 'src/models/query';

interface DocumentListStateInterface {
	activeQueryIdentifierByListType: TSMap<ActivityListTypeEnum, string>;
	dateFilter: DateRangeSelection | string;
	dateTimeRangeFilter: PreconfiguredTimeRanges;
	documentListAll: Array<DocumentListItem>;
	documentListAllSliced: Map<number, Array<DocumentListItem>>;
	documentListAllTotalCount: number;
	documentListMine: Array<DocumentListItem>;
	documentListMineSliced: Map<number, Array<DocumentListItem>>;
	documentListMineTotalCount: number;
	documentListOpen: Array<DocumentListItem>;
	documentListOpenSliced: Map<number, Array<DocumentListItem>>;
	documentListOpenTotalCount: number;
	filterBoxes: Array<FilterBoxes>;
	filterUsers: Array<FilterUsers>;
	filteredBoxIds: Array<string>;
	filteredUsers: Array<FilterUsers>;
	idoDocumentBinding: SharedQueryIdoDocumentBinding | null;
	listViewModeLarge: boolean;
	pagination: TSMap<ActivityListTypeEnum, GenericActivityListPagination>;
	queryStoreSubscriptions: Array<SerializedQuery>;
	selectedSharedQueryId: string;
	sort: TSMap<ActivityListTypeEnum, GenericActivityListSort>;
	standardBox: FilterBoxes | null;
	today: string;
}

function state(): DocumentListStateInterface {
	return {
		activeQueryIdentifierByListType: new TSMap<ActivityListTypeEnum, string>([
			[ActivityListTypeEnum.ALL, ''],
			[ActivityListTypeEnum.MINE, ''],
			[ActivityListTypeEnum.OPEN, ''],
		]),
		dateFilter: new Date().toISOString().split('T')[0],
		dateTimeRangeFilter: PreconfiguredTimeRanges.TODAY,
		documentListAll: [],
		documentListAllSliced: new Map<number, Array<DocumentListItem>>(),
		documentListAllTotalCount: 0,
		documentListMine: [],
		documentListMineSliced: new Map<number, Array<DocumentListItem>>(),
		documentListMineTotalCount: 0,
		documentListOpen: [],
		documentListOpenSliced: new Map<number, Array<DocumentListItem>>(),
		documentListOpenTotalCount: 0,
		filterBoxes: [],
		filterUsers: [],
		filteredBoxIds: [],
		filteredUsers: [],
		idoDocumentBinding: null,
		listViewModeLarge:
			localStorage.getItem(DOCUMENT_LIST_GENERIC_ACTIVITY_LIST_VIEW_MODE_LARGE) !== null
				? /true/i.test(
						localStorage.getItem(DOCUMENT_LIST_GENERIC_ACTIVITY_LIST_VIEW_MODE_LARGE) as 'false' | 'true'
					)
				: true,
		pagination: new TSMap<ActivityListTypeEnum, GenericActivityListPagination>([
			[ActivityListTypeEnum.ALL, { page: 1, rowsPerPage: 100 }],
			[ActivityListTypeEnum.ALL_MODULE_LISTS_AT_ONCE, { page: 1, rowsPerPage: 100 }],
			[ActivityListTypeEnum.MINE, { page: 1, rowsPerPage: 100 }],
			[ActivityListTypeEnum.OPEN, { page: 1, rowsPerPage: 100 }],
		]),
		queryStoreSubscriptions: [],
		selectedSharedQueryId: '',
		sort:
			localStorage.getItem(DOCUMENT_LIST_GENERIC_ACTIVITY_LIST_SORT) !== null
				? new TSMap<ActivityListTypeEnum, GenericActivityListSort>().fromJSON(
						JSON.parse(localStorage.getItem(DOCUMENT_LIST_GENERIC_ACTIVITY_LIST_SORT) as string),
						true
					)
				: new TSMap<ActivityListTypeEnum, GenericActivityListSort>([
						[
							ActivityListTypeEnum.ALL,
							{
								direction: 'DESC',
								property: 'timestamp',
							},
						],
						[
							ActivityListTypeEnum.ALL_MODULE_LISTS_AT_ONCE,
							{
								direction: 'DESC',
								property: 'timestamp',
							},
						],
						[
							ActivityListTypeEnum.MINE,
							{
								direction: 'DESC',
								property: 'timestamp',
							},
						],
						[
							ActivityListTypeEnum.OPEN,
							{
								direction: 'DESC',
								property: 'timestamp',
							},
						],
					]),
		standardBox: null,
		today: new Date().toISOString().split('T')[0],
	};
}

export default state;
